import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";
import { formatDateToDDMMYYYY } from "../pages/const";

// Register font (optional, can be customized)
Font.register({
  family: "Times New Roman",
  src: "https://db.onlinewebfonts.com/t/32441506567156636049eb850b53f02a.ttf",
});

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontFamily: "Times-Roman",
  },
  header: {
    marginBottom: 10,
    textAlign: "center",
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#8c1d1a",
    marginBottom: 4,
  },
  subtitle: {
    fontSize: 12,
    marginBottom: 2,
  },
  ledgerInfo: {
    fontSize: 10,
    marginBottom: 8,
    textAlign: "center",
  },
  table: {
    display: "table",
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#8c1d1a",
    marginBottom: 8,
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#8c1d1a",
    borderBottomStyle: "solid",
    width: "100%",
  },
  tableHeader: {
    backgroundColor: "#f0e6d2",
    fontWeight: "bold",
  },
  cellDate: {
    fontSize: 9,
    padding: 4,
    width: "8%",
    textAlign: "center",
    borderRightWidth: 1,
    borderRightColor: "#8c1d1a",
    borderRightStyle: "solid",
  },
  cellType: {
    fontSize: 9,
    padding: 4,
    width: "10%",
    textAlign: "center",
    borderRightWidth: 1,
    borderRightColor: "#8c1d1a",
    borderRightStyle: "solid",
  },
  // Credited columns (green background)
  cellCreditedGold: {
    fontSize: 9,
    padding: 4,
    width: "9%",
    textAlign: "right",
    borderRightWidth: 1,
    borderRightColor: "#8c1d1a",
    borderRightStyle: "solid",
    backgroundColor: "#e8f5ea",
    color: "#000",
  },
  cellCreditedSilver: {
    fontSize: 9,
    padding: 4,
    width: "9%",
    textAlign: "right",
    borderRightWidth: 1,
    borderRightColor: "#8c1d1a",
    borderRightStyle: "solid",
    backgroundColor: "#e8f5ea",
    color: "#000",
  },
  cellCreditedAmount: {
    fontSize: 9,
    padding: 4,
    width: "9%",
    textAlign: "right",
    borderRightWidth: 1,
    borderRightColor: "#8c1d1a",
    borderRightStyle: "solid",
    backgroundColor: "#e8f5ea",
    color: "#000",
  },
  // Debited columns (red background)
  cellDebitedGold: {
    fontSize: 9,
    padding: 4,
    width: "9%",
    textAlign: "right",
    borderRightWidth: 1,
    borderRightColor: "#8c1d1a",
    borderRightStyle: "solid",
    backgroundColor: "#fce8ea",
    color: "#000",
  },
  cellDebitedSilver: {
    fontSize: 9,
    padding: 4,
    width: "9%",
    textAlign: "right",
    borderRightWidth: 1,
    borderRightColor: "#8c1d1a",
    borderRightStyle: "solid",
    backgroundColor: "#fce8ea",
    color: "#000",
  },
  cellDebitedAmount: {
    fontSize: 9,
    padding: 4,
    width: "9%",
    textAlign: "right",
    borderRightWidth: 1,
    borderRightColor: "#8c1d1a",
    borderRightStyle: "solid",
    backgroundColor: "#fce8ea",
    color: "#000",
  },
  // Balance columns (light blue background)
  cellBalanceGold: {
    fontSize: 9,
    padding: 4,
    width: "9%",
    textAlign: "right",
    borderRightWidth: 1,
    borderRightColor: "#8c1d1a",
    borderRightStyle: "solid",
    backgroundColor: "#e8f4f7",
    color: "#000",
  },
  cellBalanceSilver: {
    fontSize: 9,
    padding: 4,
    width: "9%",
    textAlign: "right",
    borderRightWidth: 1,
    borderRightColor: "#8c1d1a",
    borderRightStyle: "solid",
    backgroundColor: "#e8f4f7",
    color: "#000",
  },
  cellBalanceAmount: {
    fontSize: 9,
    padding: 4,
    flex: 1,
    textAlign: "right",
    backgroundColor: "#e8f4f7",
    color: "#000",
    borderRightWidth: 0,
  },
  // Header styles for main columns
  headerMain: {
    fontSize: 10,
    fontWeight: "bold",
    padding: 4,
    textAlign: "center",
    borderRightWidth: 1,
    borderRightColor: "#8c1d1a",
    borderRightStyle: "solid",
  },
  headerSub: {
    fontSize: 8,
    fontWeight: "bold",
    padding: 3,
    width: "9%",
    textAlign: "center",
    borderRightWidth: 1,
    borderRightColor: "#8c1d1a",
    borderRightStyle: "solid",
  },
  headerSubLast: {
    fontSize: 8,
    fontWeight: "bold",
    padding: 3,
    flex: 1,
    textAlign: "center",
    borderRightWidth: 0,
  },
  goldHeader: {
    fontSize: 11,
    fontWeight: "bold",
    padding: 4,
    width: "30%", // 6+6+6+6+6 = 30
    textAlign: "center",
    backgroundColor: "#f0e6d2",
    borderRightWidth: 1,
    borderRightColor: "#8c1d1a",
    borderRightStyle: "solid",
    flexDirection: "row",
    display: "flex",
  },
  silverHeader: {
    fontSize: 11,
    fontWeight: "bold",
    padding: 4,
    width: "30%", // 6+6+6+6+6 = 30
    textAlign: "center",
    backgroundColor: "#f0e6d2",
    borderRightWidth: 1,
    borderRightColor: "#8c1d1a",
    borderRightStyle: "solid",
    flexDirection: "row",
    display: "flex",
  },
  amountHeader: {
    fontSize: 11,
    fontWeight: "bold",
    padding: 4,
    width: "20%", // 6+6+8 = 20
    textAlign: "center",
    backgroundColor: "#f0e6d2",
    borderRightWidth: 0,
    flexDirection: "row",
    display: "flex",
  },
  goldSubHeader: {
    fontSize: 9,
    fontWeight: "bold",
    padding: 4,
    textAlign: "center",
    backgroundColor: "#f0e6d2",
    borderRightWidth: 1,
    borderRightColor: "#8c1d1a",
    borderRightStyle: "solid",
  },
  goldSubHeaderLast: {
    fontSize: 9,
    fontWeight: "bold",
    padding: 4,
    textAlign: "center",
    backgroundColor: "#f0e6d2",
  },
  footer: {
    marginTop: 16,
    fontSize: 9,
    textAlign: "center",
  },
  highlightRow: {
    backgroundColor: "#e3f2fd", // light blue
  },
});

// Placeholder data structure for ledger
// [{date, type, particulars, credit, debit, balance, remarks}]

const KarigarLedgerPDF = ({
  ledgerData,
  karigarInfo,
  fromDate,
  toDate,
  entireReport,
}) => {
  // ledgerData: array of ledger entries
  // karigarInfo: { name, companyName, city, ... }
  // fromDate, toDate, entireReport: filters

  return (
    <Document>
      <Page size="A4" style={styles.page} orientation="landscape">
        {/* Header */}
        <View style={styles.header}>
          <Text style={styles.title}>Karigar Ledger Report</Text>
        </View>
        {/* Karigar Info */}
        <View style={styles.ledgerInfo}>
          <Text>
            Karigar: {karigarInfo?.companyName || "-"} (
            {karigarInfo?.name || "-"}) | City: {karigarInfo?.city || "-"}
          </Text>
          {entireReport || fromDate || toDate ? (
            <Text>
              {entireReport
                ? "Entire Report"
                : `From: ${formatDateToDDMMYYYY(fromDate) || "-"} To: ${
                    formatDateToDDMMYYYY(toDate) || "-"
                  }`}
            </Text>
          ) : null}
        </View>
        {/* Ledger Table */}
        <View style={styles.table}>
          {/* First header row: Main column headers */}
          <View style={[styles.tableRow, styles.tableHeader]}>
            <Text style={[styles.cellDate, { backgroundColor: "#f0e6d2" }]}>Date</Text>
            <Text style={[styles.cellType, { backgroundColor: "#f0e6d2" }]}>Tag No</Text>
            <Text style={[styles.headerMain, { backgroundColor: "#e8f5ea", width: "27%" }]}>Credited</Text>
            <Text style={[styles.headerMain, { backgroundColor: "#fce8ea", width: "27%" }]}>Debited</Text>
            <Text style={[styles.headerMain, { backgroundColor: "#e8f4f7", flex: 1, borderRightWidth: 0 }]}>Balance</Text>
          </View>
          {/* Second header row: Sub-column headers */}
          <View style={[styles.tableRow, styles.tableHeader]}>
            <Text style={[styles.cellDate, { backgroundColor: "#f0e6d2" }]}></Text>
            <Text style={[styles.cellType, { backgroundColor: "#f0e6d2" }]}></Text>
            <Text style={[styles.headerSub, { backgroundColor: "#e8f5ea" }]}>Gold</Text>
            <Text style={[styles.headerSub, { backgroundColor: "#e8f5ea" }]}>Silver</Text>
            <Text style={[styles.headerSub, { backgroundColor: "#e8f5ea" }]}>Amount</Text>
            <Text style={[styles.headerSub, { backgroundColor: "#fce8ea" }]}>Gold</Text>
            <Text style={[styles.headerSub, { backgroundColor: "#fce8ea" }]}>Silver</Text>
            <Text style={[styles.headerSub, { backgroundColor: "#fce8ea" }]}>Amount</Text>
            <Text style={[styles.headerSub, { backgroundColor: "#e8f4f7" }]}>Gold</Text>
            <Text style={[styles.headerSub, { backgroundColor: "#e8f4f7" }]}>Silver</Text>
            <Text style={[styles.headerSubLast, { backgroundColor: "#e8f4f7" }]}>Amount</Text>
          </View>
          {/* Data rows */}
          {ledgerData &&
            ledgerData.map((entry, idx) => {
              // Extract only date part (YYYY-MM-DD) from date string
              const dateValue = entry.isOpening ? "-" : (entry.date ? entry.date.split(" ")[0] : "-");
              // Calculate balance colors
              const goldBalanceColor = entry.isOpening ? "#000" : (
                parseFloat(entry.balance || 0) < 0 ? "#dc3545" : 
                parseFloat(entry.balance || 0) > 0 ? "#28a745" : "#000"
              );
              const silverBalanceColor = entry.isOpening ? "#000" : (
                parseFloat(entry.silver_balance || 0) < 0 ? "#dc3545" : 
                parseFloat(entry.silver_balance || 0) > 0 ? "#28a745" : "#000"
              );
              const amountBalanceColor = entry.isOpening ? "#000" : (
                parseFloat(entry.amount_balance || 0) < 0 ? "#dc3545" : 
                parseFloat(entry.amount_balance || 0) > 0 ? "#28a745" : "#000"
              );
              return (
                <View
                  style={[
                    styles.tableRow,
                    entry.pay_type === "CONVERTS" && styles.highlightRow,
                  ]}
                  key={idx}
                >
                  <Text style={styles.cellDate}>{dateValue}</Text>
                  <Text style={styles.cellType}>{entry.type || ""}</Text>
                  <Text style={styles.cellCreditedGold}>{entry.credit || "-"}</Text>
                  <Text style={styles.cellCreditedSilver}>{entry.silver_credit || "-"}</Text>
                  <Text style={styles.cellCreditedAmount}>{entry.amount_credit || "-"}</Text>
                  <Text style={styles.cellDebitedGold}>{entry.debit || "-"}</Text>
                  <Text style={styles.cellDebitedSilver}>{entry.silver_debit || "-"}</Text>
                  <Text style={styles.cellDebitedAmount}>{entry.amount_debit || "-"}</Text>
                  <Text style={[styles.cellBalanceGold, { color: goldBalanceColor }]}>{entry.balance || "-"}</Text>
                  <Text style={[styles.cellBalanceSilver, { color: silverBalanceColor }]}>{entry.silver_balance || "-"}</Text>
                  <Text style={[styles.cellBalanceAmount, { color: amountBalanceColor }]}>{entry.amount_balance || "-"}</Text>
                </View>
              );
            })}
        </View>
        {/* Footer */}
        <View style={styles.footer}>
          <Text>
            Generated on:{" "}
            {formatDateToDDMMYYYY(new Date().toISOString().split("T")[0])}
          </Text>
        </View>
      </Page>
    </Document>
  );
};

export default KarigarLedgerPDF;
